import baseAPI from '@/api';
import { Player } from '@/models/player';
import { UpdatePlayerInputDto } from '@/services/dto/players/update-player-input.dto';
import { AxiosResponse } from 'axios';

export async function fetchUpdatePlayer(
  data: UpdatePlayerInputDto,
): Promise<Player> {
  const response: AxiosResponse<Player> = await baseAPI.patch<Player>(
    '/players',
    data,
  );
  return response.data;
}
